<template>
  <div v-show="$store.state.window < 1100"
    :class="[($store.state.sidebar && this.$lang === 'ar' ? 'open-left-sidebar right-dir' : $store.state.sidebar ? 'open-right-sidebar left-dir' : ''), (lang === 'ar' ? 'close-left-sidebar' : 'close-right-sidebar')]"
    id="sidebar">
    <div class="middle-content">
      <div class="top-content">
        <div :class="[this.$lang === 'ar' ? 'right-dir' : '', 'menu-btn-container']">
          <div @click="$store.state.welcomeMenu = true" v-if="$store.state.window < 1100"
            class="sidebar-account account border-yellow-2 flex-center" v-on:click="reverseDialog(3)">
            <div @click="$store.state.welcomeMenu = true" v-if="$store.state.selectedNumber !== null">
              <a>
                <img src="../../assets/icons/account.svg">
                <span :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en', 'underline-1 mx-1']">{{
                  $store.state.selectedNumber }}</span>
                <img :class="[$store.state.welcomeMenu && 'rotate', 'account-arrow']"
                  src="../../assets/icons/small-black-arrow.svg" />
              </a>
            </div>
            <!--            <router-link to="/profile" v-if="$store.state.user.gsm !== null">-->
            <!--              <a>-->
            <!--                <img src="../../assets/icons/account.svg">-->
            <!--                <span :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en','underline-1 mx-1']">{{ $store.state.user.gsm }}</span>-->
            <!--                <img :class="[$store.state.welcomeMenu && 'rotate', 'account-arrow']"  src="../../assets/icons/small-black-arrow.svg" />-->
            <!--              </a>-->
            <!--            </router-link>-->
            <div v-else>
              <img src="../../assets/icons/account.svg">
              <span :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en', 'underline-1 mx-1']">iMTN</span>
              <img :class="[$store.state.welcomeMenu && 'rotate', 'account-arrow']"
                src="../../assets/icons/small-black-arrow.svg" />
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center lang-container pt-1">
          <div class="mx-2">
            <img src="../../assets/icons/lang.svg">
          </div>
          <div :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'd-flex']">
            <div :class="[this.$lang !== 'ar' ? 'bold-en' : 'lang-color', 'pointer']" @click="changeLang(1)">En</div>
            <div class="mx-1">
              <div class="lang-color"> / </div>
            </div>
            <div :class="[this.$lang === 'ar' ? 'bold-en' : 'lang-color', 'pointer']" @click="changeLang(0)">Ar</div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="[this.$lang === 'ar' ? 'right-align bold-ar' : 'left-align bold-en left-dir', 'sidebar-items-container']">
      <div class="sidebar-el-container">
        <div class="sidebar-el" v-for="(item, i) in sections.items" :key="i">
          <div @click="handleNested(i)" :class="[lang === 'ar' ? '' : '', 'd-flex']">
            <div style="cursor: pointer;">
              <router-link :class="$store.state.activeSectionNav === i ? 'yellow-text' : ''" :to="sections.paths[i]"><a>{{
                item }}</a></router-link>
            </div>
            <!--            <div v-if="i !== 0" class="mx-2 arrow-transition" :id="`rotate-${i}`"><img src="../../assets/icons/black.svg"/></div>-->
          </div>
          <div v-if="i !== 0" class="wrapper" :id="`nest-${i}`">
            <div :class="[lang === 'ar' ? 'regular-ar' : 'regular-en', 'inner']">
              <div v-for="(item, index) in 4" :key="index">
                item
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="[this.$lang === 'ar' ? 'right-align' : 'left-align', 'copy-right']">
        <div :class="this.$lang === 'ar' ? 'regular-ar' : 'regular-en'">{{ $t('copyright') }}</div>
        <div :class="lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ date.getFullYear() }} MTN ©</div>
      </div>
    </div>
    <sidebar-account v-if="$store.state.welcomeMenu && $store.state.sidebar" />
  </div>
</template>
<script>
import SidebarAccount from '@/components/sidebar/sidebar-account/SidebarAccount'
import utils from '../../shared/utils'
// import $ from 'jquery'
export default {
  components: { SidebarAccount },
  data () {
    return {
      date: new Date(),
      reverseDialog: utils.changeDialogStatus,
      dialogs: utils.dialogs,
      lang: localStorage.getItem('lang'),
      // sections: ['Home', 'About MTN', 'Products & Services', 'MTN Offers', 'Media Center'],
      sections: { items: this.$t('navbar.sectionNavbar'), paths: ['/home', '/products', '/bundles', '/offers', '/roaming'] },
      welcomeMenu: false,
      checkedLang: false,
      changeLang: utils.changeLang,
      showNested: false
    }
  },
  created () {
    if (this.$lang === 'ar') {
      this.checkedLang = true
    }
    // this.$watch(() => {
    //   return this.$route.path
    // }, (val) => {
    //   this.$store.state.sidebar = false
    // })
    this.$watch(() => {
      return this.$route.path
    }, (val) => {
      this.$store.state.sidebar = false
      for (let i = 0; i < this.sections.paths.length; i++) {
        if (val === this.sections.paths[i]) {
          this.$store.state.activeSectionNav = i
        }
      }
    })
  },
  mounted () {
  },
  methods: {
    onChangeEventHandler () {
      this.checkedLang = !this.checkedLang
      this.checkedLang ? this.changeLang(0) : this.changeLang(1)
    },
    handleNested (i) {
      // if (i !== 0) {
      //   if ($(`#nest-${i}`)[0].classList.contains('is-open')) {
      //     $(`#nest-${i}`).removeClass('is-open')
      //     $(`#rotate-${i}`).removeClass('rotation')
      //   } else {
      //     $(`#nest-${i}`).addClass('is-open')
      //     $(`#rotate-${i}`).addClass('rotation')
      //   }
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";

.yellow-text {
  color: #FFCB05 !important;
}

#sidebar {
  height: calc(100vh - 110px);
  position: fixed;
  width: 100vw;
  background: rgba(242, 242, 242, .8);
  backdrop-filter: blur(40px);
  top: 110px;
  z-index: 1000;
  transition-duration: .4s;
  overflow-y: auto !important;
}

.close-left-sidebar {
  left: -100vw
}

.close-right-sidebar {
  right: -100vw
}

.open-left-sidebar {
  left: 0 !important;
}

.open-right-sidebar {
  right: 0 !important;
}

.wrapper {
  font-size: 14px;
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows .2s ease-out;
}

.is-open {
  grid-template-rows: 1fr;
}

.inner {
  overflow: hidden;
  padding: 0 20px;
}

.arrow-transition {
  transition: all .3s ease-in-out;
}

.rotation {
  transform: rotate(180deg);
}

.sidebar-items-container {
  width: 100%;
  min-height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 50px 0 0 0;
  //cursor: pointer; //
}

.sidebar-el-container {
  height: 65%;
  line-height: 3;
  font-size: 17px;
}

.bottom-content {
  height: 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 0;
}

.sidebar-el {
  padding: 0 2rem;
}

.sidebar-account {
  //width: 120px;
  //height: 40px;
  width: 140px;
  height: 44px;
  border-radius: 10px;
  margin: 0 0 15px 0;
  cursor: pointer;
}

.sidebar-account img {
  width: 20px;
  height: 20px;
  margin: 0 2px;
}

.menu-btn-container {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 2rem;
}

.middle-content {
  width: 100%;
  margin: 20px 0;
}

.lang-container {
  width: 100%;
  padding: 0 1.6rem;
}

.lang-color {
  color: rgba(29, 29, 29, 0.4);
}

.copy-right {
  font-size: 12px;
  padding: 0 2rem;
  margin-bottom: 8px;
}

@media (min-width: 620px) {
  //.copy-right,
  //.menu-btn-container,
  //.sidebar-el{
  //  padding: 0 2.2rem;
  //}
}
</style>
